module.exports = __webpack_public_path__ + "static/media/Untitledhhhh.86a5c183.jpg";